import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  business_expenses: 'Business Expenses',
  construction: 'Construction',
  donation_charitable_contribution: 'Donation / Charitable Contribution',
  education_training: 'Education / Training',
  family_support: 'Family Support',
  freight: 'Freight',
  goods_purchased: 'Goods Purchased',
  investment_capital: 'Investment Capital',
  investment_proceeds: 'Investment Proceeds',
  living_expenses: 'Living Expenses',
  loan_credit_repayment: 'Loan / Credit Repayment',
  medical_services: 'Medical Services',
  pension: 'Pension',
  personal_remittance: 'Personal Remittance',
  professional_business_services: 'Professional / Business Services',
  real_estate: 'Real Estate',
  taxes: 'Taxes',
  technical_services: 'Technical Services',
  transfer_to_own_account: 'Transfer to Own Account',
  travel: 'Travel',
  wages_salary: 'Wages / Salary',
  other_services: 'Other Services',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const PAYMENT_REASONS: Record<Language, Record<LabelsLanguage, string>> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    business_expenses: 'Gastos Empresariales',
    construction: 'Construcción',
    donation_charitable_contribution: 'Donación / Contribución Caritativa',
    education_training: 'Educación / Capacitación',
    family_support: 'Apoyo Familiar',
    freight: 'Flete',
    goods_purchased: 'Bienes Comprados',
    investment_capital: 'Capital de Inversión',
    investment_proceeds: 'Rendimientos de Inversiones',
    living_expenses: 'Gastos de Vida',
    loan_credit_repayment: 'Reembolso de Préstamo / Crédito',
    medical_services: 'Servicios Médicos',
    pension: 'Pensión',
    personal_remittance: 'Remesa Personal',
    professional_business_services: 'Servicios Profesionales / Empresariales',
    real_estate: 'Bienes Raíces',
    taxes: 'Impuestos',
    technical_services: 'Servicios Técnicos',
    transfer_to_own_account: 'Transferencia a Propia Cuenta',
    travel: 'Viaje',
    wages_salary: 'Salarios',
    other_services: 'Otros Servicios',
  },
};

export default PAYMENT_REASONS;
